import { EVENT_TRACK, EVENT_TRACK_SUCCESS, EVENT_TRACK_ERROR, EVENT_TRACK_EMPTY } from '../../actions';

const initialState = {
  data: null,
  message: null,
  loading: false,
  success: false,
  error: false,
};

const EventTrack = (state = initialState, action) => {
  switch (action.type) {
    case EVENT_TRACK:
      state = {
        ...state,
        // data: null,
        loading: true,
        success: false,
        error: false,
        message: null,
      };
      break;

    case EVENT_TRACK_SUCCESS:
      state = {
        ...state,
        data: action.payload,
        loading: false,
        success: true,
        error: false,
        message: null,
      };
      break;

    case EVENT_TRACK_ERROR:
      state = {
        ...state,
        data: null,
        loading: false,
        success: false,
        error: true,
        message: action.payload,
      };
      break;

    case EVENT_TRACK_EMPTY:
      state = {
        ...initialState,
      };
      break;

    default:
      state = { ...state };
      break;
  }
  return state;
};

export default EventTrack;
